import { ButtonMui } from 'src/components/ButtonMui'
import { SelectMui } from 'src/components/SelectMui'
import styled from 'styled-components'

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  width: 100%;
`

export const CustomSelect = styled(SelectMui)`
  width: 30%;
  height: 3rem !important;
`

export const CustomButton = styled(ButtonMui)`
  width: 14rem;
`

export const ContainerButtons = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
`
